/**
 * Helpers for consuming server-rendered app config: JSON attribute parsing and
 * deep-merging localized label payloads over an app's English defaults.
 */

export function parseJson(text, fallback) {
  if (!text) {
    return fallback;
  }

  try {
    return JSON.parse(text);
  } catch {
    return fallback;
  }
}

export function deepMerge(base, overrides) {
  const result = { ...base };

  for (const [key, value] of Object.entries(overrides ?? {})) {
    if (value && typeof value === "object" && !Array.isArray(value) && typeof result[key] === "object") {
      result[key] = deepMerge(result[key], value);
    } else {
      result[key] = value;
    }
  }

  return result;
}
